import { ChangeType, RecordableCategory, RecordableCategoryUpdate, RecordablePriorityName, RecordableStatusName } from "./index";

export class RecordableDivisionDefault {
    public marketId: number;
    public recordablePriorityStatusDefaults: RecordablePriorityStatusDefault[];
    public defaultRecordableCategories: RecordableCategory[];
    public recordableCategoryUpdate: RecordableCategoryUpdate[];
}

export class RecordablePriorityStatusDefault {
    public recordablePriorityStatusDefaultId: number;
    public marketId: number;
    public recordablePriorityName: RecordablePriorityName;
    public recordableStatusName: RecordableStatusName;
    public isDefault: boolean;
    public changeType: ChangeType;
    public priorityOn: boolean;
}
